import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueCryptojs from 'vue-cryptojs';
Vue.use(VueCryptojs);

Vue.use(VueI18n);

import { messages } from './messages'

let localeValue = 'de';

switch (Vue.CryptoJS.SHA256(location.host).toString(Vue.CryptoJS.enc.Hex)) {
    case 'd404d80e4e98c2529ddf51eec929755894669104f5211923c1abc7876a55c2ed':
        localeValue = 'lv';
        break;
    default:
        localeValue = 'de';
        break;
}

const i18n = new VueI18n({
    locale: localeValue,
    messages,
});

export default i18n;